import React from "react";
import { CalendarDays } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useConversion } from "@/context/ConversionContext";
import { useCookies } from "@/context/CookieContext";
import { useScrolledPast, useElementInView } from "@/hooks/useReveal";

// Intelligent appointment button: appears after scroll, hidden while the hero
// CTA is visible, when the final contact/footer is in view, when a modal is
// open, or when the cookie banner still needs a decision.
export default function ScrollAppointmentButton() {
  const { t } = useLang();
  const { openCalendly, calendlyOpen, formOpen } = useConversion();
  const { decided } = useCookies();
  const scrolled = useScrolledPast(0.24);
  const nearFooterOrContact = useElementInView("[data-hide-appointment]");

  const show = scrolled && !calendlyOpen && !formOpen && decided && !nearFooterOrContact;

  return (
    <>
      {/* Desktop: compact pill in the bottom-right, left of the WhatsApp bubble */}
      <div
        className={`fixed bottom-6 right-24 z-30 hidden md:block transition-all duration-300 ${
          show ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0 pointer-events-none"
        }`}
      >
        <button type="button" onClick={openCalendly} data-testid="scroll-appointment-desktop" className="btn-coral shadow-lift !py-3 !px-5">
          <CalendarDays className="h-5 w-5" strokeWidth={2.2} />
          {t.cta.bookAppointment}
        </button>
      </div>

      {/* Mobile: compact bottom bar (WhatsApp remains available via the bubble above) */}
      <div
        className={`fixed inset-x-0 bottom-0 z-30 md:hidden transition-transform duration-300 ${
          show ? "translate-y-0" : "translate-y-full"
        }`}
        data-testid="scroll-appointment-mobile"
      >
        <div className="mx-3 mb-3 rounded-2xl border border-nek-border bg-white p-2 shadow-lift">
          <button type="button" onClick={openCalendly} className="btn-coral w-full !py-3 text-sm">
            <CalendarDays className="h-4 w-4" /> {t.cta.bookAppointment}
          </button>
        </div>
      </div>
    </>
  );
}
